import { useLazyQuery, useQuery } from '@apollo/client';
import { Box, Collapse, IconButton, IconButtonProps } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { styled } from '@material-ui/styles';
import { StandardAlert } from 'component/StandardAlert';
import { Text } from 'component/customize_style_component/styled_title';
import HeaderBack from 'component/layout/header_back';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import NavigationBottom from 'component/navigation/navigation_bottom_home';
import NavigationBottomStylist from 'component/navigation/navigation_bottom_stylist';
import { User, UserType } from 'component/stylist_profile_header/types';
import format from 'date-fns/format';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import { useHeightContent } from 'hooks/useHeighContent';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { useDispatch } from 'react-redux';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import { updateStatus } from 'redux/quiz_manager/personasSlice';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import { EGENDER, EQuizId, quizContextType } from 'types/quiz';
import { getUserProfilePhoto } from 'utils/getUserProfilePhoto';
import { ReactComponent as BodyShape } from '../../assets/svg/body_shape.svg';
import { ReactComponent as ColorMulti } from '../../assets/svg/color_multi.svg';
import { ReactComponent as StyleTip } from '../../assets/svg/hanger_tip.svg';
import ColorTipsPopup from './color_tips';
import { useStyles } from './style';
import utils, { isValidDate } from 'utils/utils';
import { useUrlQuery } from 'hooks/useUrlQuery';
import StylePreferenItem from './components/StylePreferenItem';

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}
const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton style={{ padding: 0 }} {...other} />;
})(({ theme, expand }: any) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(90deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));
function ProfileCustomer() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [user, setUser] = useState<User>();
    const { userName } = useParams<{ userName: string }>();
    const [prefix, setPrefix] = useState<string>('My');
    const [isDisableLink, setIsDisableLink] = useState(false);
    const [expanded, setExpanded] = useState(Boolean(true));
    const [birthday, setBirthday] = useState('');
    const urlQuery = useUrlQuery();

    useEffect(() => {
        if (urlQuery.get('expandedStylePreferences') === '1') {
            setExpanded(true);
        } else setExpanded(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickMyStylePreferences = () => {
        history.push(`${PATH.MY_STYLE_PREFERENCES}`);
    };
    const [getUser, { loading }] = useLazyQuery(USER_DETAIL, {
        onCompleted(response) {
            setUser(response?.me);
        },
    });
    const height: any = use100vh();
    const [showColor, setShowColor] = useState(false);
    const [getUserByUserName, { loading: getUserByUserNameLoading }] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(response) {
            setUser(response?.getUserByUserName);
        },
    });
    const heightTemp = useHeightContent(['main', 'personal'], height - 56 - 50 - 20);

    useEffect(() => {
        if (userName) {
            setPrefix('');
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        } else {
            getUser();
        }
    }, [userName, getUser, getUserByUserName]);
    useEffect(() => {
        if (userName && user?.userType === UserType.Stylist) {
            history.push(`${PATH.STYLIST_PROFILE}/${userName}`);
        }
    }, [user, userName, history]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data } = useQuery(GET_QUIZ_RESPONSE, {
        variables: {
            input: {
                quizId: user?.gender === 'female' ? 'customer_women_style_quiz' : 'customer_men_style_quiz',
                contextType: quizContextType,
                contextId: user?.gender === 'female' ? 'customer_women_style_quiz' : 'customer_men_style_quiz',
                userId: user?.id,
            },
        },
        onCompleted: (data) => {
            const listQuestions = _.valuesIn(data.getQuizResponse?.questions);
            if (data && listQuestions && listQuestions.length > 0) setIsDisableLink(false);
            else setIsDisableLink(true);
        },
        skip: !user,
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [getUserBirthday, { loading: loadingBirthday }] = useLazyQuery(GET_QUIZ_RESPONSE, {
        variables: {
            input: {
                quizId: EQuizId.MY_BIRTHDAY_QUIZ,
                contextType: quizContextType,
                contextId: EQuizId.MY_BIRTHDAY_QUIZ,
                userId: user?.id,
            },
        },
        onCompleted: (data) => {
            if (
                data.getQuizResponse?.answers?.birthday_question?.value &&
                isValidDate(new Date(data.getQuizResponse?.answers?.birthday_question?.value))
            ) {
                setBirthday(format(new Date(data.getQuizResponse?.answers?.birthday_question?.value), 'd LLLL yyyy'));
            } else setBirthday('');
        },
    });
    useEffect(() => {
        if (user) {
            getUserBirthday();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const hanldeRoutingSection = (customerViewPath, detailPath) => {
        history.push(userName ? `${customerViewPath}/${userName}` : detailPath);
    };

    return (
        <>
            <div className={classes.wrapper}>
                <div
                    id="main"
                    className={classes.main}
                    style={{
                        minHeight: `${height}px`,
                    }}
                >
                    {user ? (
                        <div>
                            <HeaderBack backTo="/home" isBack={false} title="Profile" isLogo={false} />
                            <NavLink
                                to={userName ? `${PATH.CONSUMER_PROFILE_INFO}/${userName}` : PATH.PROFILE_INFO}
                                style={{ textDecoration: 'none' }}
                            >
                                <div id="personal" className={classes.personal}>
                                    <figure className={classes.personalFigure}>
                                        <img
                                            src={getUserProfilePhoto(user)}
                                            alt="profile"
                                            className={classes.personalImg}
                                        />
                                    </figure>
                                    <div className={classes.personalInfo}>
                                        <Text size={16} margin={'4px 0'}>
                                            {user?.firstName} {user?.lastName}
                                        </Text>
                                        <Text margin={'4px 0'} opacity={'0.5'}>
                                            {user?.phone}
                                        </Text>
                                        {Boolean(userName) && (
                                            <Text margin={'4px 0'} opacity={'0.5'}>
                                                {birthday}
                                            </Text>
                                        )}
                                    </div>
                                </div>
                            </NavLink>
                            <div
                                className={classes.contnentPage}
                                style={{
                                    maxHeight: `${heightTemp}px`,
                                }}
                            >
                                <div
                                    className={classes.tips}
                                    onClick={() => hanldeRoutingSection(PATH.CONSUMER_STYLE_GUIDE, PATH.STYLE_GUIDE)}
                                >
                                    <div className={classes.tipsTitle}>
                                        <span
                                            style={{
                                                fontSize: 16,
                                                fontWeight: 600,
                                                color: themes.palette.primary.main,
                                                fontFamily: 'PoppinsRegular',
                                                padding: 10,
                                                margin: 0,
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {prefix} Style Guide
                                        </span>
                                    </div>
                                    <div className={classes.tipsContent}>
                                        <div className={classes.tipItem} onClick={() => 0 && setShowColor(true)}>
                                            <div className={classes.tip}>
                                                <ColorMulti width={28} height={28} color="primary" />
                                            </div>
                                            <p className={classes.tipsItemTitle}>Colors</p>
                                        </div>
                                        <div className={classes.tipItem}>
                                            <div className={classes.tip}>
                                                <StyleTip width={28} height={28} color="primary" />
                                            </div>
                                            <p className={classes.tipsItemTitle}>Styles</p>
                                        </div>
                                        <div className={classes.tipItem}>
                                            <div className={classes.tip}>
                                                <BodyShape width={28} height={28} color="primary" />
                                            </div>
                                            <p className={classes.tipsItemTitle}>Bodyshape</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.myOptions}>
                                    <ul style={{ margin: 0, padding: 0 }}>
                                        <li
                                            className={classes.option}
                                            onClick={() => hanldeRoutingSection(PATH.CONSUMER_WARDROBE, PATH.WARDROBE)}
                                        >
                                            {prefix} Wardrobe
                                            <span>
                                                <ArrowForwardIosIcon
                                                    style={{ color: themes.palette.primary.main, width: 15 }}
                                                />
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div className={classes.myOptions}>
                                    <ul style={{ margin: 0, padding: 0 }}>
                                        <li className={classes.option} style={{ display: 'block' }}>
                                            <Box
                                                className={classes.stylePreferences}
                                                onClick={handleClickMyStylePreferences}
                                            >
                                                {prefix} Style Preferences{' '}
                                                <ExpandMore
                                                    expand={expanded}
                                                    aria-expanded={expanded}
                                                    aria-label="show more"
                                                >
                                                    <ArrowForwardIosIcon
                                                        style={{ color: themes.palette.primary.main, width: 15 }}
                                                    />
                                                </ExpandMore>
                                            </Box>
                                            <Collapse in={expanded} timeout="auto" unmountOnExit>
                                                <Box>
                                                    <ul className={classes.optionParent}>
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() => {
                                                                hanldeRoutingSection(
                                                                    PATH.QUIZ_PERSONAS,
                                                                    PATH.QUIZ_PERSONAS,
                                                                );
                                                                dispatch(updateStatus(true));
                                                            }}
                                                        >
                                                            {prefix} Persona{' '}
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>{' '}
                                                        </li>
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                hanldeRoutingSection(
                                                                    PATH.BODY_SHAPE_QUIZ,
                                                                    PATH.BODY_SHAPE_QUIZ,
                                                                )
                                                            }
                                                        >
                                                            {prefix} Body Shape{' '}
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>{' '}
                                                        </li>
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                hanldeRoutingSection(
                                                                    PATH.BODY_TYPE_QUIZ,
                                                                    PATH.BODY_TYPE_QUIZ,
                                                                )
                                                            }
                                                        >
                                                            {prefix} Body Type{' '}
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>{' '}
                                                        </li>

                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                hanldeRoutingSection(PATH.SKIN_TONE, PATH.SKIN_TONE)
                                                            }
                                                        >
                                                            {prefix} Skin Tone{' '}
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>{' '}
                                                        </li>

                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                hanldeRoutingSection(
                                                                    PATH.SKIN_UNDERTONE,
                                                                    PATH.SKIN_UNDERTONE,
                                                                )
                                                            }
                                                        >
                                                            {prefix} Skin Undertone{' '}
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>{' '}
                                                        </li>
                                                        {user?.gender === EGENDER.FEMALE && (
                                                            <li
                                                                className={classes.optionChild}
                                                                onClick={() =>
                                                                    hanldeRoutingSection(
                                                                        PATH.HAIR_COLOR,
                                                                        PATH.HAIR_COLOR,
                                                                    )
                                                                }
                                                            >
                                                                {prefix} Hair Color{' '}
                                                                <span>
                                                                    <ArrowForwardIosIcon
                                                                        style={{
                                                                            color: themes.palette.primary.main,
                                                                            width: 15,
                                                                        }}
                                                                    />
                                                                </span>{' '}
                                                            </li>
                                                        )}
                                                        <StylePreferenItem
                                                            isDisableLink={isDisableLink}
                                                            prefix={prefix}
                                                            path={PATH.EYE_COLOR}
                                                            styleName="Eye Color"
                                                        />
                                                        <StylePreferenItem
                                                            isDisableLink={isDisableLink}
                                                            prefix={prefix}
                                                            path={PATH.MEASUREMENTS_QUIZ}
                                                            styleName="Measurements"
                                                        />
                                                        {!isDisableLink && (
                                                            <li
                                                                className={classes.optionChild}
                                                                onClick={() => {
                                                                    if (!isDisableLink) {
                                                                        if (userName) {
                                                                            history.push(
                                                                                `${PATH.STYLE_QUIZ}/${userName}`,
                                                                            );
                                                                        } else {
                                                                            history.push(PATH.STYLE_QUIZ);
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                {prefix} Style{' '}
                                                                <span>
                                                                    <ArrowForwardIosIcon
                                                                        style={{
                                                                            color: themes.palette.primary.main,
                                                                            width: 15,
                                                                            opacity: `${isDisableLink ? 0.5 : 1}`,
                                                                        }}
                                                                    />
                                                                </span>{' '}
                                                            </li>
                                                        )}
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                hanldeRoutingSection(PATH.COLOR_QUIZ, PATH.COLOR_QUIZ)
                                                            }
                                                        >
                                                            {prefix} Colors{' '}
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>{' '}
                                                        </li>
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                history.push(
                                                                    userName
                                                                        ? `${PATH.PATTERN_QUIZ}/${userName}`
                                                                        : PATH.PATTERN_QUIZ,
                                                                )
                                                            }
                                                        >
                                                            {prefix} Patterns
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>
                                                        </li>
                                                        {user?.gender === EGENDER.FEMALE && (
                                                            <li
                                                                className={classes.optionChild}
                                                                onClick={() =>
                                                                    history.push(
                                                                        userName
                                                                            ? `${PATH.HIJAB_QUIZ}/${userName}`
                                                                            : PATH.HIJAB_QUIZ,
                                                                    )
                                                                }
                                                            >
                                                                {prefix} Hijab
                                                                <span>
                                                                    <ArrowForwardIosIcon
                                                                        style={{
                                                                            color: themes.palette.primary.main,
                                                                            width: 15,
                                                                        }}
                                                                    />
                                                                </span>
                                                            </li>
                                                        )}
                                                        {user?.gender === EGENDER.FEMALE && (
                                                            <StylePreferenItem
                                                                isDisableLink={isDisableLink}
                                                                prefix={prefix}
                                                                path={PATH.SHOW_OFF}
                                                                styleName="Show Off"
                                                            />
                                                        )}
                                                        {user?.gender === EGENDER.FEMALE && (
                                                            <StylePreferenItem
                                                                isDisableLink={isDisableLink}
                                                                prefix={prefix}
                                                                path={PATH.COVER}
                                                                styleName="Cover"
                                                            />
                                                        )}
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                history.push(
                                                                    userName
                                                                        ? `${PATH.FASHION_RESTRICTION}/${userName}`
                                                                        : PATH.FASHION_RESTRICTION,
                                                                )
                                                            }
                                                        >
                                                            {prefix} Fashion Restrictions
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>
                                                        </li>
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                hanldeRoutingSection(PATH.SIZES_QUIZ, PATH.SIZES_QUIZ)
                                                            }
                                                        >
                                                            {prefix} Sizes{' '}
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>{' '}
                                                        </li>
                                                        {!isDisableLink && (
                                                            <li
                                                                className={classes.optionChild}
                                                                onClick={() => {
                                                                    if (!isDisableLink) {
                                                                        if (userName) {
                                                                            history.push(
                                                                                `${PATH.BUDGET_QUIZ}/${userName}`,
                                                                            );
                                                                        } else {
                                                                            history.push(PATH.BUDGET_QUIZ);
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                {prefix} Budget{' '}
                                                                <span>
                                                                    <ArrowForwardIosIcon
                                                                        style={{
                                                                            color: themes.palette.primary.main,
                                                                            width: 15,
                                                                            opacity: `${isDisableLink ? 0.5 : 1}`,
                                                                        }}
                                                                    />
                                                                </span>{' '}
                                                            </li>
                                                        )}
                                                        <StylePreferenItem
                                                            isDisableLink={isDisableLink}
                                                            prefix={prefix}
                                                            path={PATH.SOCIAL_MEDIAS}
                                                            styleName="Social Medias"
                                                        />
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                hanldeRoutingSection(PATH.USER_LIKES, PATH.USER_LIKES)
                                                            }
                                                        >
                                                            {prefix} Likes
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>
                                                        </li>
                                                        <li
                                                            className={classes.optionChild}
                                                            onClick={() =>
                                                                hanldeRoutingSection(
                                                                    PATH.USER_DISLIKES,
                                                                    PATH.USER_DISLIKES,
                                                                )
                                                            }
                                                        >
                                                            {prefix} Dislikes
                                                            <span>
                                                                <ArrowForwardIosIcon
                                                                    style={{
                                                                        color: themes.palette.primary.main,
                                                                        width: 15,
                                                                    }}
                                                                />
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </Box>
                                            </Collapse>
                                        </li>
                                        <li
                                            className={classes.option}
                                            onClick={() => hanldeRoutingSection(PATH.CONSUMER_PHOTOS, PATH.MY_PHOTOS)}
                                        >
                                            {prefix} Photos
                                            <span>
                                                <ArrowForwardIosIcon
                                                    style={{ color: themes.palette.primary.main, width: 15 }}
                                                />
                                            </span>{' '}
                                        </li>
                                        <li className={classes.option} onClick={() => history.push(PATH.SOCIAL_MEDIAS)}>
                                            {prefix} Social Medias
                                            <span>
                                                <ArrowForwardIosIcon
                                                    style={{ color: themes.palette.primary.main, width: 15 }}
                                                />
                                            </span>{' '}
                                        </li>
                                        <li
                                            className={classes.option}
                                            onClick={() => hanldeRoutingSection(PATH.USER_LIKES, PATH.USER_LIKES)}
                                        >
                                            {prefix} Likes
                                            <span>
                                                <ArrowForwardIosIcon
                                                    style={{
                                                        color: themes.palette.primary.main,
                                                        width: 15,
                                                    }}
                                                />
                                            </span>
                                        </li>
                                        <li
                                            className={classes.option}
                                            onClick={() => hanldeRoutingSection(PATH.USER_DISLIKES, PATH.USER_DISLIKES)}
                                        >
                                            {prefix} Dislikes
                                            <span>
                                                <ArrowForwardIosIcon
                                                    style={{
                                                        color: themes.palette.primary.main,
                                                        width: 15,
                                                    }}
                                                />
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div className={classes.myOptions}>
                                    <ul style={{ margin: 0, padding: 0 }}>
                                        {!utils.isAppInWidgetMode() && (
                                            <li
                                                className={classes.option}
                                                onClick={() =>
                                                    hanldeRoutingSection(PATH.CONSUMER_ORDERS, PATH.ODER_LIST)
                                                }
                                            >
                                                {prefix} Orders
                                                <span>
                                                    <ArrowForwardIosIcon
                                                        style={{ color: themes.palette.primary.main, width: 15 }}
                                                    />
                                                </span>{' '}
                                            </li>
                                        )}
                                        {!userName && (
                                            <li
                                                className={classes.option}
                                                onClick={() => history.push(PATH.MY_STYLE_REQUESTS)}
                                            >
                                                {prefix} Style Requests
                                                <span>
                                                    <ArrowForwardIosIcon
                                                        style={{ color: themes.palette.primary.main, width: 15 }}
                                                    />
                                                </span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                                {false && (
                                    <span className={classes.bringInfo}>
                                        Billing Info{' '}
                                        <span>
                                            <ArrowForwardIosIcon
                                                style={{ color: themes.palette.primary.main, width: 15 }}
                                            />
                                        </span>{' '}
                                    </span>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div style={{ height: '100%', padding: '30px 24px 0' }}>
                            <StandardAlert
                                height={`calc( ${height}px - 100px)`}
                                title={'User Not Found.'}
                                body={
                                    'Sorry, the user you are looking for is either not available or the URL is incorrect.'
                                }
                                isIcon={false}
                            />
                        </div>
                    )}
                </div>
                {user?.userType === UserType.Stylist || userName ? <NavigationBottomStylist /> : <NavigationBottom />}
                {showColor && <ColorTipsPopup onClose={() => setShowColor(false)} />}
                {(loading || getUserByUserNameLoading || loadingBirthday) && <LoadingDataSpinner />}
            </div>
        </>
    );
}

export default ProfileCustomer;
